module.exports = __webpack_public_path__ + "img/Remote-Marketing-Executive.d9cb24ba.webp";